export const PROPERTY_STATUS = 'status';
export const PROPERTY_DATA = 'data';
export const PROPERTY_ERROR = 'error';
export const PROPERTY_FETCHED = 'fetched';
export const PROPERTY_UPLOADED = 'uploaded';
export const PROPERTY_IS_FETCHING = 'isFetching';
export const PROPERTY_IS_UPLOADING = 'isUploading';
export const PROPERTY_FETCH_META = 'fetchDataMeta';
export const PROPERTY_TOTAL_ITEMS = 'totalItems';
